export class NoReservationToRemoveError extends Error {

  code?: string = 'reservation/none-to-remove';
}
